import StartEventHook from './StartEventHook'
import Logger from '../Log'
import { bidderForCode } from '../utils'
import FillManager from '../FillManager'
import VidazooFillMethod from '../fillers/VidazooFillMethod'

const Log = Logger.for('VidazooEventHook')

export default class VidazooStartHook extends StartEventHook {
  constructor () {
    super('VidazooDesktop')
  }

  run (remoteConfig) {
    return new Promise((resolve, reject) => {
      const bidder = bidderForCode('vidazoo_desktop', remoteConfig.bidders(), true)
      if (!bidder) {
        Log.debug('No vidazoo desktop adapter, skipping setup')
        return resolve()
      }

      /* if (!Device.isDesktop()) {
        Log.debug('On mobile, skipping vidazoo desktop method')
        return resolve()
      } */

      Log.debug('Vidazoo using desktop script widget')

      const widgetId = bidder.params.widgetId
      if (!widgetId) {
        Log.warn('Missing vidazoo widgetId in config!')
        return resolve()
      }

      Log.debug('Found vidazoo desktop adapter, registering fill method')

      FillManager.register(new VidazooFillMethod(bidder))

      resolve()
    })
  }
}
